import { CircularProgress, IconButton } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import csvImg from '../assets/images/export_csv.png';
import { capitalizeFirstLetter } from '../utils/capitalize';
import ExportCsvModal from './modals/ExportCsvModal';

interface ExportCsvIconProps {
    onExport: (startDate: string, endDate: string, fileName?: string, delimiter?: string) => void;
    exportIsLoading?: boolean;
    disabled?: boolean;
    initDate: Date;
    children?: React.ReactNode;
    subTitle?: string;
}

const ExportCsvIcon: React.FC<ExportCsvIconProps> = ({ onExport, exportIsLoading, initDate, children, disabled, subTitle }) => {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <IconButton
                className="pad-0-imp"
                onClick={() => setShowModal(true)}
                title={capitalizeFirstLetter(t('downloadCsv'))}
                color="secondary"
                disabled={disabled}
            >
                {exportIsLoading ? <CircularProgress size={24} color="primary" /> : <img src={csvImg} height={25} />}
            </IconButton>
            {showModal && (
                <ExportCsvModal open={showModal} initDate={initDate} handleClose={() => setShowModal(false)} onExport={onExport} subTitle={subTitle}>
                    {children}
                </ExportCsvModal>
            )}
        </>
    );
};

export default ExportCsvIcon;
